export default __webpack_public_path__ + "images/icons/pin-b-9325c0305939d454d73ca477a109ba74.svg";